<template>
  <div class="section-block right-block">
    <div class="section-title">文书生成记录</div>
    <div v-if="effectiveList.length" class="doc-list">
      <el-timeline>
        <el-timeline-item :timestamp="item.createTime" placement="top" v-for="(item, index) in effectiveList"
                          :key="item.id || index">
          <div class="timeLine-content">
<!--            <div class="timeLine-content-title">{{item.typeName||''}}</div>-->
            <div class="timeLine-txt">
              <div>文书类型：{{item.typeName||''}}</div>
              <div> 文件名称：{{(item.typeName||'') +'-'+(item.referenceNumber||'')}}.docx</div>
            </div>
            <div class="timeLine-content-bt" v-if="item.fileUrl">
              <el-button type="primary" link size="small" @click="handleView(item)">查看</el-button>
              <el-button type="warning" link size="small" @click="handleDownload(item)">下载</el-button>
            </div>
          </div>
        </el-timeline-item>

      </el-timeline>
    </div>
    <div v-else class="doc-empty">暂无已生效文书</div>
  </div>
</template>

<script>
import {getDocumentList,previewDocument} from '@/api/recognition/survey'
import { previewFile} from '@/utils/downLoad'

export default {
  name: 'EffectiveDocList',
  data() {
    return {
      listLoading: false,
      effectiveList: []
    }
  },
  created() {
    this.loadDocumentList()
  },
  methods: {

    resolvePreviewUrl(url) {
      if (!url) return ''
      if (url.startsWith('http')) return url
      return (this.imageUrlprefix || process.env.VUE_APP_IMAGEURLPREFIX || '') + url
    },
    handleView(item) {
      if (!item) return
      const url = item.fileUrl || item.url
      if (!url) {
        this.$message.warning('该文书暂无预览地址')
        return
      }
      previewDocument({id:item.id}).then(response=>{
        previewFile(response)
      })
    },
    handleDownload(item) {
      if (!item || !(item.fileUrl || item.url)) {
        this.$message.warning('暂无文件地址')
        return
      }
      const url = this.resolvePreviewUrl(item.fileUrl || item.url)
      window.open(url, '_blank')
    },
    handleDelete(item) {
      this.$confirm('确认删除该文书？', '提示', {type: 'warning'})
          .then(() => {
            this.effectiveList = this.effectiveList.filter(
                (r) => (r.id || r) !== (item.id || item)
            )
            this.$message.success('删除成功')
          })
          .catch(() => {
          })
    },
    loadDocumentList() {
      let {id, pageType} = this.$route.query
      getDocumentList({
        caseId: id,
        generateType: pageType
      }).then(res => {
        if (res?.code === 200) {
          this.effectiveList = res.data || []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.section-block {
  margin-bottom: 0;
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  padding-left: 0px;
  padding-top: 0px;

  .section-title {
    position: relative;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    padding-left: 11px;
    margin-bottom: 12px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 12px;
      border-radius: 20px;
      background: var(--vt-c-blue, #409eff);
    }
  }
}

.right-block .section-title {
  flex-shrink: 0;
}

.doc-list-scrollbar {
  min-height: 200px;
  max-height: 320px;

  :deep(.el-scrollbar__wrap) {
    overflow-x: hidden;
  }
}

.doc-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.doc-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.doc-item-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
}

.doc-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.doc-item-body {
  flex: 1;
  min-width: 0;
}

.doc-item-title {
  font-weight: 500;
  color: #303133;
  font-size: 14px;
  margin-bottom: 6px;
}

.doc-item-time {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}

.doc-item-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.doc-empty {
  text-align: center;
  color: #909399;
  padding: 60px 0;
  font-size: 14px;
}

/deep/ .el-timeline-item__timestamp {
  color: rgba(41, 125, 238, 1);
  font-family: "Alibaba PuHuiTi 3.0";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding-top: 0px;
  margin-bottom: 0px;
}

/deep/ .el-timeline-item__node {
  border: 2px solid rgba(255, 255, 255, 1);
  box-sizing: border-box;
  background: rgba(41, 125, 238, 1);
  box-shadow: 0px 2px 4px rgba(41, 125, 238, 0.5);
}

.timeLine-content {
  border-radius: 4px;
  margin-top: 12px;
  background: rgba(247, 247, 247, 1);

  .timeLine-content-title {
    color: rgba(42, 51, 71, 1);
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    padding: 12px;
    border-bottom: 1px solid rgba(233, 234, 236, 1);
  }

  .timeLine-txt {
    padding: 15px 12px 12px;
    color: rgba(70, 77, 90, 1);
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  .timeLine-content-bt {
    padding: 0px 12px 12px;
    display: flex;
    gap: 12px;

    .el-button {
      border-radius: 4px;
      padding: 6px 12px;
    }

  }
}

/deep/ .el-timeline-item__tail {
  border: 0px;
  width: 2px;
  background-image: linear-gradient(to bottom, rgba(52, 139, 255, 1) 50%, transparent 50%);
  /* 第一个值=线宽，第二个值=段长+间距 */
  background-size: 1px 8px;
  background-repeat: repeat-y;
  background-position: center;
}
</style>
